<div class="container-fluid" id="jsonTextArea">
    <div class="row" style="padding-left: 10%; padding-top: 6%;">
        <div class="col-8">
            <div class="form-group green-border-focus">
                <div class="alert alert-primary" role="alert">CAP Server Redirected Page (With the callback Json)
                </div>
                <form>
                    <textarea class="form-control" rows="15" id="payhubdata">{{walletJson | json}}</textarea>
                </form>
            </div>
        </div>
    </div>
</div>